import React, {Component} from 'react';
import {Redirect} from 'react-router';
import './style.less';

class FacilityDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      form: {
        goods_name: '',
        bind_status: '',
        agent_no: '',
        agent_name: '',
        bind_date: '',
        bind_core_merchant_code: '',
        bind_core_merchant_name: '',
        unbind_date: '',
        bind_merchant_name: '',
        bind_merchant_code: '',
        activate_status: '',
        order_no: '',
        activate_date: '',
        device_sn: '',
        ctivate_price: '',
        buy_price: '',
        gmt_created: ''
      }
    };
  }
  componentWillMount() {
    this.setState({form: this.props.form});
  }
  componentWillReceiveProps(props) {
    this.setState({form: props.form});
  }
  getActivate(status) {
    switch (Number(status)) {
      case 1:
        return '未激活';
      case 2:
        return '激活中';
      case 3:
        return '已激活';
      default:
        return '未激活';
    }
  }
  getState(status) {
    switch (status) {
      case '1':
        return '已绑定';
      case '2':
        return '未绑定';
      case '3':
        return '锁定中';
      default:
        return '未绑定';
    }
  }
  getActivationCodeType(type) {
    switch (type) {
      case 0:
        return '通用型';
      case 1:
        return '联拓通道专属';
    }
  }
  render() {
    const {form, redirect} = this.state;
    if (redirect) return (<Redirect to="/login" />);
    return (
      <div className="facility-blocks facility-detail-blocks">
        <ul className="detail-items">
          <li>
            <label>商品名称：</label>
            <div>{form.goods_name}</div>
          </li>
          <li>
            <label>商品绑定状态：</label>
            <div>{this.getState(form.bind_status)}</div>
          </li>
          <li>
            <label>激活码类型：</label>
            <div>{this.getActivationCodeType(form.activation_code_type)}</div>
          </li>
          <li>
            <label>所属代理商编号/名称：</label>
            <div className={!form.agent_no ? 'hide' : null}>{form.agent_no}/{form.agent_name}</div>
          </li>
          <li style={{width: '100%'}}>
            <label>绑定核心商户编号/名称：</label>
            <div className={!form.bind_core_merchant_code ? 'hide' : null}>{form.bind_core_merchant_code}/{form.bind_core_merchant_name}</div>
          </li>
          <li>
            <label>商品锁定/绑定时间：</label>
            <div>{form.bind_date}</div>
          </li>
          <li>
            <label>商品解绑时间：</label>
            <div>{form.unbind_date}</div>
          </li>
          <li style={{width: '100%'}}>
            <label>绑定门店编号/门店名称：</label>
            <div className={!form.bind_merchant_code ? 'hide' : null}>{form.bind_merchant_code}/{form.bind_merchant_name}</div>
          </li>
          <li>
            <label>商品激活状态：</label>
            <div>{this.getActivate(form.activate_status)}</div>
          </li>
          <li>
            <label>订单编号：</label>
            <div>{form.order_no}</div>
          </li>
          <li>
            <label>商品激活时间：</label>
            <div>{form.activate_date}</div>
          </li>
          <li>
            <label>商品sn码：</label>
            <div>{form.device_sn}</div>
          </li>
          <li>
            <label>商品激活价格：</label>
            <div>{form.goods_activate_price}</div>
          </li>
          <li>
            <label>商品购买价格：</label>
            <div>{form.buy_price}</div>
          </li>
          <li>
            <label>创建时间：</label>
            <div>{form.gmt_created}</div>
          </li>
        </ul>
      </div>
    );
  }
}
export default FacilityDetail;



// WEBPACK FOOTER //
// ./src/containers/backEnd/facilityMangement/facilitydetail.jsx